export default __webpack_public_path__ + "static/media/serviceRequestHistory.79146fff.svg";